module.exports = __webpack_public_path__ + "static/media/companyLogo2.3939efaf.png";